import { InjectionToken } from '@angular/core';

/**
 * Common surface for analytics tracker adapters. Each vendor (GTM, Metrika,
 * future trackers) implements this interface; `AnalyticsService` fans out
 * to all registered trackers without naming any vendor directly.
 *
 * Consent updates are vendor-specific and not part of this interface —
 * `AnalyticsService.updateConsent` still routes to `GtmService` (Consent
 * Mode v2) directly.
 */
export interface ITracker {
    bootstrap(): void;
    pageView(url: string, title?: string): void;
    event(name: string, params?: Record<string, unknown>): void;
    setUser(userId: string, props?: Record<string, unknown>): void;
}

/**
 * Multi-provider token. Each tracker adapter is provided once at the root
 * level (`{ provide: TRACKERS, useExisting: GtmService, multi: true }`).
 */
export const TRACKERS: InjectionToken<readonly ITracker[]> = new InjectionToken<readonly ITracker[]>('TRACKERS');
